import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ClearIcon from '@mui/icons-material/Clear';
import { toast } from "react-toastify";
import { IconButton } from "@mui/material";

const DragAndDropImages = ({ inputUpdated, allowedFileTypes, maxFileSize }) => {
    const [selectedFiles, setSelectedFiles] = useState([]);
    const inputRef = React.useRef(null);

    const showSaveErrorMessage = (message) => {
        toast.error(message, {
            position: toast.TOP_LEFT,
            style: {
                backgroundColor: "#eb4335",
                width: "650px",
                color: "#FFFFFF",
                left: "500px",
                theme: "colored",
            },
        });
    };

    function getFileExtension(filename) {
        return filename.split('.').pop().toLowerCase();
    }

    const handleFileDrop = (e) => {
        e.preventDefault();
        const files = e.dataTransfer.files;
        handleFileSelected(files);
    };

    const handleFileDrag = (e) => {
        e.preventDefault();
        e.stopPropagation();
    };

    const handleFileChange = (e) => {
        e.preventDefault();
        const files = e.target.files;
        handleFileSelected(files);
    };

    const handleFileSelected = (files) => {
        const selectedFileLinks = [];
        const fileUrls = [];
        const validFiles = [];

        for (let i = 0; i < files.length; i++) {
            const file = files[i];
            const fileType = getFileExtension(file.name);

            if (file.size > maxFileSize) {
                showSaveErrorMessage(`Please choose a file that is less than ${maxFileSize / 1024 / 1024}MB`);
            } else if (!allowedFileTypes.map(type => type.toLowerCase()).includes(fileType)) {
                showSaveErrorMessage(`Please ensure document is of type: ${allowedFileTypes.join(', ')}`);
            } else {
                const fileUrl = URL.createObjectURL(file);

                fileUrls.push(fileUrl);
                selectedFileLinks.push(
                    <a href={fileUrls[i]} key={i} target="_blank" rel="noopener noreferrer" style={{ fontSize: "small", marginRight: "10px" }}>
                        {file.name}
                    </a>
                );
                validFiles.push(file);
            }
        }

        setSelectedFiles(selectedFileLinks);
        inputUpdated(validFiles);
    };

    const onButtonClick = (e) => {
        e.preventDefault();
        inputRef.current.click();
    };

    const removeFile = (e) => {
        e.preventDefault();
        setSelectedFiles([]);
        inputUpdated([]);
    };

    return (
        <form
            id="form-file-upload"
            data-testid={"form-file-upload1"}
            onDrop={handleFileDrop}
            onDragLeave={handleFileDrag}
            onDragOver={handleFileDrag}
            onSubmit={(e) => e.preventDefault()}
            draggable={"true"}
            className={"inputWidth"}
        >
            <input
                id="input-file-upload"
                data-testid={"input-file-upload1"}
                ref={inputRef}
                type="file"
                multiple={true}
                onChange={handleFileChange}
            />
            <label
                className="UploadInputWidth"
                id="label-file-upload"
                htmlFor="input-file-upload"
            >
                <Grid container direction="column" className="DragDropText">
                    <Grid item style={{ color: "#FF6600" }}>
                        <UploadFileIcon />
                    </Grid>
                    <button
                        className="upload-button"
                        onClick={onButtonClick}
                    >
                        Click to Upload
                    </button>
                    or drag and drop
                    <Grid item>{allowedFileTypes.join(', ')} (max. {maxFileSize / 1024 / 1024}MB)</Grid>
                    <div data-testid={"selected-files-links1"}>{selectedFiles}
                        <IconButton data-testid={"removeDocument"} hidden={selectedFiles.length <= 0} onClick={removeFile}>
                            <ClearIcon />
                        </IconButton>
                    </div>
                </Grid>
            </label>
        </form>
    );
};

export default DragAndDropImages;
